import { merge } from "lodash/fp";
import { Translation } from "../../types";
import enAu from "../en-AU";

/**
 * English (GB) translations - extends English (AU).
 */
const enGb: Translation = merge(enAu, {} as Partial<Translation>);

export default enGb;
